import { useEmployeeProfile } from 'Context/ProfileContext'
import { EmployeeSingleType } from 'Models/employeeType'
import profileService from 'Services/profileService'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

export const useResolvedProfile = () => {
  const location = useLocation()
  const { customerAccountId } = useParams()
  const { profile: contextProfile } = useEmployeeProfile()

  const [profile, setProfile] = useState<EmployeeSingleType | null>(null)

  useEffect(() => {
    const isOwnProfile = ['/profile', '/leave'].some((path) => location.pathname.startsWith(path))

    if (isOwnProfile) {
      setProfile(contextProfile)
    } else if (customerAccountId) {
      profileService.getProfile(customerAccountId).then((res) => {
        setProfile(res.data.data)
      })
    }
  }, [location.pathname, contextProfile, customerAccountId])

  return { profile, setProfile }
}
